import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { isAndroid, isMobile, osVersion } from "react-device-detect";
import { getVodEditUrl, goLogin, isWebbiewShareable, webviewSharePost, inAppStore, getAndroidCompareVersion } from "helpers";
import { fetchTitleBlind, fetchLiveBlind } from "actions/blind.action";
import { blindVod, cancelNoticePost, deletePost, deleteVod } from "actions/post.action";
import { storeLaterViewVod } from "actions/post.action";
import { storeHomePin } from "actions/home.action";

import { STBBS_DOMAIN, VOD_EDITOR_DOMAIN } from "constant/config";
import { UCC } from "constant/board";
import { CATCH } from "constant/filetype";

import MoreButton from "components/MoreButton";
import Share from "components/share/Share";
import { ButtonLink } from "components/ButtonLink";
import ModalWindow from "components/ModalWindow";
import ReviewDelete from "components/boards/post/vod/layer/ReviewDelete";
import PostMove from "components/boards/post/PostMove";
import PlaylistLayer from "components/boards/post/vod/layer/playlist/PlaylistLayer";
import ClipDelete from "components/boards/post/vod/layer/ClipDelete";
import {useHistory} from "react-router";

import Report from "pages/station/report/Report";

const PostMoreButton = ({ post, authority, top, right, pageCreated = false }) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const lang = document.documentElement.lang;
	const history = useHistory();

	// 로그인 정보 세팅
	const { is_login, user_id } = useSelector((state) => state.authenticationReducer);

	// 핀 고정
	const handleStorePin = () => {
		if (post?.board_type === 105) {
			if (post?.ucc?.file_type === 'REVIEW') {
				pageCreated = global.bj_id === user_id
			}
		}
		dispatch(storeHomePin(post.title_no, post.board_type, null, history, pageCreated));
	};

	// 나중에 보기 추가 / 삭제
	const handleLaterView = () => {
		storeLaterViewVod(post.title_no);
	};

	// 게시글 공유하기
	const handleSharePost = (changeContent, close) => (event) => {
		event.stopPropagation();
		event.nativeEvent.stopImmediatePropagation();

		// 앱내 웹뷰 공유 기능 사용
		if (isWebbiewShareable()) {
			webviewSharePost(post);
			close();
			return;
		}

		// 공유 팝업 노출
		changeContent(<Share post={post} close={close} top={top} right={right} />);
	};

	// VOD 게시글 수정 페이지 이동
	const handleOpenVodEdit = () => {
		window.location = getVodEditUrl(post);
	};

	// 게시글 삭제
	const handleDeletePost = (type) => () => {
		if (!window.confirm(t("삭제 하시겠습니까?"))) {
			return;
		}

		switch (type) {
			// 유저 VOD 블라인드 처리
			case "blind":
				dispatch(blindVod(post.title_no));
				break;

			// VOD 게시글 삭제
			case "vod":
				dispatch(deleteVod(post.title_no));
				break;

			// 일반 게시글 삭제
			case "post":
			default:
				dispatch(deletePost(post.title_no));
				break;
		}
	};

	// 게시글 이동하기
	const handleMovePost = (changeContent, close) => (event) => {
		event.stopPropagation();
		event.nativeEvent.stopImmediatePropagation();

		changeContent(
			<PostMove post={post} titleNo={post.title_no} oldBbsNo={post.bbs_no} close={close} right={right} top={top} left={610} />,
		);
	};

	// 게시글 공지 해제
	const handleCancelNoticePost = () => {
		dispatch(cancelNoticePost(post.title_no));
	};

	// 로그인 여부 확인
	const handleGoLogin = () => {
		if (!is_login && window.confirm(t("로그인이 필요합니다. 로그인 하시겠습니까?"))) {
			goLogin();
		}
	};
    
    const handleTargetBlind = (title_no, blind_id, modalClose) => {
		if (!is_login) {
			goLogin();
		} else {
			// 신고하기 기능과 신고 후 삭제/차단 기능 분리
			if(window.confirm(t("이 게시글을 숨기겠습니까?"))) {
				(async (title_no, blind_id, modalClose) => {
					// 블라인드 API 호출
					// dispatch 필요함 HIDE_POST_SUCCESS
                    dispatch(fetchTitleBlind(title_no, blind_id, modalClose));
                    
				})(title_no, blind_id, modalClose);
            }
        }
    }

	const handleGoChapter = (stationNo, bbsNo, titleNo) => {		
		// szWork=chapter&nStationNo=21030219&nBbsNo=67897048&nTitleNo=125655305&szNewWindow=on

		window.open(`${STBBS_DOMAIN}/vodupload/index.php?szWork=chapter&nStationNo=${stationNo}&nBbsNo=${bbsNo}&nTitleNo=${titleNo}&szNewWindow=on`);
		return false;
	}

	return (
		<MoreButton
			trigger={
				<button type="button" className="btn-detail">
					<span>상세정보</span>
				</button>
			}
			right={right}
			top={top}
		>
			{({ changeContent, close }) => (
				<>
					{/* 나중에 보기 추가/삭제 */}
					{/* 캐치 제외 추가 */}
					{post.board_type === UCC && post.ucc && (
						post.ucc.file_type===CATCH ?
						null :
						<button type="button" onClick={handleLaterView}>
							<span>
								나중에 보기
							</span>
						</button>
					)}

					{/* 재생목록에 영상 추가 - 로그인 유저 */}
					{authority.is_ucc_playlist_addable && is_login && (
						<ModalWindow
							onClose={close}
							classNames={{
								modal: "modal_modal_style",
							}}
							trigger={
								<button type="button">
									<span>
										재생목록에 담기
									</span>
								</button>
							}
						>
							{(close) => <PlaylistLayer vod={post} close={close} />}
						</ModalWindow>
					)}

					{/* 비로그인 재생목록 영상 추가 시 로그인 페이지 이동 */}
					{authority.is_ucc_playlist_addable && !is_login && post.ucc && (
						post.ucc.file_type===CATCH ?
						null :
						<button type="button" onClick={handleGoLogin}>
							<span>
								재생목록에 담기
							</span>
						</button>
					)}

					{/* 공유 버튼 */}
					{authority.is_board_shareable && (
						<button type="button" data-id="share" onClick={handleSharePost(changeContent, close)}>
							<span data-id="share">
								공유하기
							</span>
						</button>
					)}

					{/* 일반 게시글 수정 페이지 이동 */}
					{authority.is_board_updatable && (
						<ButtonLink type="button" to={`/${global.bj_id}/post/${post.title_no}/edit`}>
							<span>
								수정하기
							</span>
						</ButtonLink>
					)}

					{/* VOD 게시글 PC 수정 페이지 이동 */}
					{!isMobile && authority.is_ucc_updatable && (
						<ButtonLink to={getVodEditUrl(post)} target="_blank">
							<span>
								수정하기
							</span>
						</ButtonLink>
					)}

					{/* VOD 게시글 모바일 수정 페이지 이동 */}
					{isMobile && !(isAndroid && parseInt(osVersion) < 5) && authority.is_ucc_updatable && (
						<button onClick={handleOpenVodEdit}>
							<span>
								수정하기
							</span>
						</button>
					)}

					{/* 블라인드 처리 */}
					{authority.is_blind_deletable && (
						<button type="button" onClick={handleDeletePost("blind")}>
							<span>
								삭제하기
							</span>
						</button>
					)}

					{/* 다시보기 사유 기입 삭제 */}
					{authority.is_reason_deletable && (
						<ModalWindow
							trigger={
								<button type="button">
									<span>
										삭제하기
									</span>
								</button>
							}
						>
							{(close) => <ReviewDelete vod={post} close={close} />}
						</ModalWindow>
					)}

					{/* 유저 클립 사유기입 삭제 */}
					{authority.is_clip_reason_deletable && (
						<ModalWindow
							onClose={close}
							trigger={
								<button type="button">
									<span>
										삭제하기
									</span>
								</button>
							}
						>
							{(close) => <ClipDelete vod={post} close={close} />}
						</ModalWindow>
					)}

					{authority.is_catch_reason_deletable && (
						<ModalWindow
							onClose={close}
							trigger={
								<button type="button">
									<span>
										삭제하기
									</span>
								</button>
							}
						>
							{(close) => <ClipDelete vod={post} close={close} />}
						</ModalWindow>
					)}

					{/* 일반 게시글 삭제 */}
					{authority.is_board_deletable && (
						<button type="button" onClick={handleDeletePost("post")}>
							<span>
								삭제하기
							</span>
						</button>
					)}

					{/* VOD 게시글 삭제 */}
					{authority.is_ucc_deletable && (
						<button type="button" onClick={handleDeletePost("vod")}>
							<span>
								삭제하기
							</span>
						</button>
					)}

					{/* 게시글 이동하기 */}
					{authority.is_movable && !isMobile && (
						<button type="button" onClick={handleMovePost(changeContent, close)}>
							<span>
								이동하기
							</span>
						</button>
					)}

					{/* 게시글 공지 해제 */}
					{authority.is_notice_cancelable && (
						<button type="button" onClick={handleCancelNoticePost}>
							<span>
								공지 해제
							</span>
						</button>
					)}

					{/* VOD 중간 광고 세팅 */}
					{authority.is_ucc_mid_roll_settable && !isMobile && (
						<ButtonLink
							to={`${STBBS_DOMAIN}/vodupload/index.php?szWork=midroll&nStationNo=${post.station_no}&nBbsNo=${post.bbs_no}&nTitleNo=${post.title_no}&szNewWindow=on`}
							target="_blank"
						>
							<span>
								중간광고 설정
							</span>
						</ButtonLink>
					)}

					{/* 챕터설정 페이지 이동 */}
					{!isMobile && authority.is_ucc_chapter_settable && (
						// stationNo, bbsNo, titleNo
						<button type="button" onClick={() => handleGoChapter(post.station_no, post.bbs_no, post.title_no)}>
							<span>
								챕터설정<em className="new">new</em>
							</span>
						</button>
					)}

					{/* VOD 편집하기 */}
					{authority.is_ucc_editable && lang === "ko" && !isMobile && (
						<ButtonLink to={`${VOD_EDITOR_DOMAIN}/${post.title_no}`} target="_blank">
							<span>
								편집하기
							</span>
						</ButtonLink>
					)}
					
					{/* 게시글 홈 고정 */}
					{(authority.is_pin_fixable || authority.is_vod_pin_fixable) && (
						<button type="button" onClick={handleStorePin}>
							<span>
								홈에 고정하기
							</span>
						</button>
					)}

					{/* 게시글 신고하기 - PC */}
					{authority.is_reportable && !isMobile && (
						<ModalWindow
							trigger={
								<button type="button">
									<span>
										신고하기
									</span>
								</button>
							}
						>
							{(close) => (
								<Report
									onClose={close}
									data={{
										common_idx: post.title_no,
										board_type: post.board_type,
										writer_id: post.user_id,
										writer_nick: post.user_nick,
										title: post.title_name,
										is_report_station : false,
									}}
								/>
							)}
						</ModalWindow>
					)}

					{/* 게시글 신고하기 - 모바일 */}
					{authority.is_reportable && isMobile && (
						<ButtonLink
							to={`/${global.bj_id}/report`}
							state={{
								common_idx: post.title_no,
								board_type: post.board_type,
								writer_id: post.user_id,
								writer_nick: post.user_nick,
								title: post.title_name,
								is_report_station : false,
							}}
							isLogin={is_login}
						>
							<span>
								신고하기
							</span>
						</ButtonLink>
					)}

					{/* 게시글 차단하기 AOS 6.20.6 버전에서만 제공 - 모바일 */}
					{authority.is_reportable && getAndroidCompareVersion("6.20.6") && (
						<button type="button" onClick={() => {handleTargetBlind(post.title_no, post.user_id, close)}}>
							<span>
								이 게시글 숨기기
							</span>
						</button>
					)}
				</>
			)}
		</MoreButton>
	);
};

export default PostMoreButton;
